import { BusinessDays } from './business-days'
import { DaysOfWeek } from './date-util'

export default class ClinicConstantsMenStg {
  /* clinic情報 */
  static SAPPORO = {
    medicalBusinessId: 'c1172203-5b5e-4fa7-9499-28b163f33565',
    name: '札幌',
    clinicId: 'baae079dbb8b4f3eb3bca96b346341b7',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: []
  }

  static TOKYO = {
    medicalBusinessId: 'c1172203-5b5e-4fa7-9499-28b163f33565',
    name: '東京',
    clinicId: '2f1a0654b43e4bdf851356879c1442e2',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: []
  }

  static SINJUKU = {
    medicalBusinessId: 'c1172203-5b5e-4fa7-9499-28b163f33565',
    name: '新宿',
    clinicId: 'ffe4faf2d4fd4284adb24c82b4d5609d',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: []
  }

  static NAGOYA = {
    medicalBusinessId: 'c1172203-5b5e-4fa7-9499-28b163f33565',
    name: '名古屋',
    clinicId: '5656606e81424995bff7fd10353e399f',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: false } }
  }

  static OSAKA = {
    medicalBusinessId: 'c1172203-5b5e-4fa7-9499-28b163f33565',
    name: '大阪',
    clinicId: '250b937bd357419fb42ccf865dbc5c31',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: []
  }

  static FUKUOKA = {
    medicalBusinessId: 'c1172203-5b5e-4fa7-9499-28b163f33565',
    name: '福岡',
    clinicId: '8273e6e44f644071915e5dbfe2f3bfdf',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: true } }
  }

  static DEMO = {
    medicalBusinessId: 'c1172203-5b5e-4fa7-9499-28b163f33565',
    name: 'デモ',
    clinicId: 'c14a8a05711b4499acef7de0578ee56f',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: true } }
  }

  static CLINICS = [
    ClinicConstantsMenStg.SAPPORO,
    ClinicConstantsMenStg.TOKYO,
    ClinicConstantsMenStg.SINJUKU,
    ClinicConstantsMenStg.NAGOYA,
    ClinicConstantsMenStg.OSAKA,
    ClinicConstantsMenStg.DEMO,
    ClinicConstantsMenStg.FUKUOKA
  ]
}
